<template>
  <div>
    <div v-if="generalInfo && generalInfo.contact_message" class="contact-banner">
      {{ generalInfo.contact_message }}
    </div>
  <v-container class="my-5 px-10 contact-container align-sm-center">
    <div class="bpg-page-heading">
      <h1>Grand Rapids Store Information</h1>
    </div>
    <div class="d-flex flex-column support-column flex-sm-row mt-sm-4 justify-sm-space-around align-center font-default-size">
      <div>
        <h2 class="font-large mt-3">
          Visit Us
        </h2>
        <address>
          Baker Book House<br>
          {{ generalInfo.address }}<br>
          {{ generalInfo.city___state___zip }}<br>
        </address>
      </div>
      <div>
        <h2 class="font-large mt-3">
          Store Hours
        </h2>
        <div v-if="!generalInfo.monday && !generalInfo.tuesday && !generalInfo.wednesday && !generalInfo.thursday && !generalInfo.friday">
                Monday&mdash;Friday: {{ generalInfo.weekday }}
              </div>
              <div v-if="generalInfo.monday">
                Monday: {{ generalInfo.monday }}
              </div>
              <div v-if="generalInfo.tuesday">
                Tuesday: {{ generalInfo.tuesday }}
              </div>
              <div v-if="generalInfo.wednesday">
                Wednesday: {{ generalInfo.wednesday }}
              </div>
              <div v-if="generalInfo.thursday">
                Thursday: {{ generalInfo.thursday }}
              </div>
              <div v-if="generalInfo.friday">
                Friday: {{ generalInfo.friday }}
              </div>
        <div>
          Saturday: {{ generalInfo.saturday }}
        </div>
        <div>
          Sunday: {{ generalInfo.sunday }}
        </div>
        <div v-if="generalInfo.holiday_1">
          {{ generalInfo.holiday_1 }}
        </div>
        <div v-if="generalInfo.holiday_2">
          {{ generalInfo.holiday_2 }}
        </div>
        </div>
      <div>
        <h2 class="font-large mt-3">
          Call Us (Bookstore/Cafe)
        </h2>
        <div>Phone: {{ generalInfo.phone }}</div>
        <div>Toll-Free: {{ generalInfo.toll_free }}</div>
        <div>Fax: {{ generalInfo.fax }}</div>
      </div>
    </div>
    <div class="bpg-page-heading mt-4">
      <h1>Order and Sales Support</h1>
    </div>
    <div class="d-flex flex-column flex-sm-row support-column align-start justify-sm-space-around">
      <div class="bpg-support-page-heading">
        <div>
          <h2 class="font-large">
          {{ generalInfo.used_book_title }}
          </h2>
        </div>
        <div class="flex-sm-row sub-heading-container justify-center">
          <span class="sub-heading">{{ generalInfo.used_books_message }}</span>
        </div>
        <div>
          <a
          v-if="generalInfo.used_books_link"
          :href="generalInfo.used_books_link"
          >
            <base-button
              :text="generalInfo.used_books_button_text"
              x-large
            />
          </a>
        </div>
      </div>

      <div class="bpg-support-page-heading">
        <div>
          <h2 class="font-large">
          {{ generalInfo.online_support_title }}
          </h2>
        </div>
        <div class="flex-sm-row sub-heading-container justify-center">
          <span class="sub-heading">{{ generalInfo.online_support_message }}</span>
        </div>
        <div>
          <nuxt-link to="/contact/faq/orders-faq">
<base-button
            :text="generalInfo.online_support_button_text"
            x-large
          />
</nuxt-link>
        </div>
      </div>

      <div class="bpg-support-page-heading">
        <div>
          <h2 class="font-large">
          {{ generalInfo.general_support_title }}
          </h2>
        </div>
        <div class="flex-sm-row sub-heading-container justify-center">
          <span class="sub-heading">{{ generalInfo.general_support_message }}</span>
        </div>
        <div>
          <nuxt-link to="/contact/faq/general-faq">
          <base-button
            :text="generalInfo.general_support_button_text"
            x-large
          />
          </nuxt-link>
        </div>
      </div>
</div>
</v-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Contact',
  head () {
    return {
      title: 'Contact'
    }
  },
  data: () => {
    return {
      form: {
        message: ''
      },
      valid: false,
      submitting: false,
      submitted: false,
      error: null
    }
  },
  computed: {
    ...mapState({
      generalInfo: state => state.layout.generalInfo
    })
  },
  methods: {
    submit () {
      this.submitting = true
      this.error = null
      return this.$axios.post('store/contact', this.form)
        .then(() => {
          this.submitted = true
        })
        .catch((err) => {
          this.error = err.isChapterException && err.isUserFriendly ? err.message
            : 'Error submitting contact information. Please try again.'
        })
        .finally(() => {
          this.submitting = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import './scss/variables';
  .bpg-page-heading {
    text-align:center;
  }
  .support-column{
    justify-content:start;
    text-align:center;
    border-bottom:1px solid #dcdcdc;
    padding-bottom:2em;
      .bpg-support-page-heading {
      width: 100%;
      text-align:center;
      padding-top:2em;
      h1 {
        font-size: 3em;
      }
    }
    .sub-heading-container {
      max-width:80%;
      margin:0 auto;
      margin-top:1em;
      min-height:7em;
    .sub-heading {
        font-weight:200 !important;
        font-size:1.5em;
      }
    }
  }
  .contact-banner {
    background-color: #e3e7ec;
    height: 4.8em;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    text-transform: uppercase;
  }
  .contact-container {
    max-width: 1200px;
  }

  .row > div {
    padding-top: 0;
    padding-bottom: 5px;
  }

  address {
    font-style: normal;
  }
</style>
